<template>
  <router-link class="home-action-button" :to="targetRoute">
    <span class="home-action-button__label">{{ label }}</span>
  </router-link>
</template>

<script>
export default {
  name: 'HomeActionButton',
  props: {
    label: {
      type: String,
      required: true
    },
    routeName: {
      type: String,
      required: true
    }
  },
  computed: {
    targetRoute() {
      return { name: this.routeName };
    }
  }
};
</script>

<style scoped>
.home-action-button {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 0;
  border: 0;
  text-decoration: none;
  cursor: pointer;
  touch-action: manipulation;
}

.home-action-button__label {
  display: block;
  width: auto;
  height: auto;
  line-height: 1.2;
  text-align: center;
  white-space: nowrap;
}

.home-action-button:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: 2px;
}

.home-action-button:active {
  opacity: 0.6;
}
</style>
